/*
 * Copyright (c) 2024. Dave van Rijn Development
 */
import './style/dvrdRadio.scss';

import classNames from 'classnames';
import React, {MouseEventHandler, useContext, useMemo} from 'react';
import {ControlContext} from "../util/controlContext";
import {editColor} from "../util/colorUtil";

interface Props {
    onClick: MouseEventHandler;
    onMouseEnter: MouseEventHandler;
    onMouseLeave: MouseEventHandler;
    checked: boolean;
    hasHover: boolean;
    id: string;
    labelPosition: 'left' | 'right';
    disabled?: boolean;
    label?: string;
    baseColor?: string;
    title?: string;
    className?: string;
}

export default function DvrdRadio(props: Props) {
    const context = useContext(ControlContext);
    const {
        checked, label, labelPosition, hasHover, onClick, title, disabled, onMouseLeave, onMouseEnter, className, id
    } = props;
    const baseColor = useMemo(() => {
        return props.baseColor ?? context.baseColor
    }, [props.baseColor, context.baseColor]);

    function getBulletContainerStyle() {
        let borderColor: string = baseColor;
        if (disabled) borderColor = 'color-gray-4';
        else if (hasHover) borderColor = editColor(-.2, baseColor);
        return {borderColor};
    }

    function getBulletStyle() {
        let color: string = baseColor;
        if (disabled) color = 'color-gray-4';
        else if (hasHover) color = editColor(-.2, baseColor);
        return {backgroundColor: color};
    }

    function renderLabel(position: 'left' | 'right') {
        if (!label?.length || position !== labelPosition) return;
        return <label className='dvrd-radio-button-label'>{label}</label>;
    }

    function renderBullet() {
        return (
            <div className='dvrd-radio-bullet-container' style={getBulletContainerStyle()}>
                <div className='ripple' style={{backgroundColor: baseColor}}/>
                <div className={classNames('dvrd-radio-bullet', checked && 'checked')} style={getBulletStyle()}/>
            </div>
        )
    }

    return (
        <div
            className={classNames('dvrd-radio-button', disabled && 'disbled', !!context.noAnimations && 'no-animations', className)}
            onClick={onClick} id={id} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave} title={title}>
            {renderLabel('left')}
            {renderBullet()}
            {renderLabel('right')}
        </div>
    )
}